import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import logoSuperDucha from "../../../../assets/images/logo-super-tanque.png";
import { TextContainer, Title } from "./SuccessPaymentStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemLaundryStyles";
import { LaundryStore, restartInteraction, setPage } from "../../../../stores/LaundryStore/LaundryStore";
import { createTotemOrder } from "../../../../services/laundryService";
import { PAGES } from "../../../../stores/LaundryStore/LaundryStore.types";
import { toast } from "react-toastify";
import { activateLaundryMachineEffect } from "../../../../stores/LaundryStore/LaundryStore.effects";

const SuccessPayment: React.FC = () => {
  const {
    selectedLaundryType,
    selectedPayment,
    totemId,
    selectedLaundryMachine,
    cieloTransactionId,
    taxId,
  } = useUnit(LaundryStore);

  useEffect(() => {
    if (
      selectedLaundryType?.id &&
      selectedLaundryType?.price &&
      selectedPayment?.type &&
      totemId &&
      selectedLaundryMachine?.id
    ) {
      createTotemOrder({
        laundryTypeId: selectedLaundryType.id,
        laundryTypePrice: selectedLaundryType.price.toString(),
        laundryMachineId: selectedLaundryMachine.id,
        paymentType: selectedPayment.type,
        taxId: taxId || "",
        totemId,
        cieloTransactionId: cieloTransactionId,
      }).catch((error) => {
        console.error("Error creating totem order:", error);
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const payload = {
      deviceId: selectedLaundryMachine?.deviceId || "",
      type: selectedLaundryType?.type || "",
      pulse: selectedLaundryType?.type.includes("12") ? 2 : 1,
      pulseDuration: 150,
      pulseInterval: 100,
    };

    setTimeout(() => {
      activateLaundryMachineEffect(payload);
    }, 5000);

    const unsubscribeDone = activateLaundryMachineEffect.doneData.watch(() => {
      toast.success(`Comando de ativação enviado com sucesso!`);
    });
    const unsubscribeFail = activateLaundryMachineEffect.fail.watch(() => {
      handleFailedActivation();
    });
    const unsubscribeFinally = activateLaundryMachineEffect.finally.watch(() => {
      handleFinish();
    });

    return () => {
      unsubscribeFail();
      unsubscribeDone();
      unsubscribeFinally();
    };
  }, [selectedLaundryMachine]);

  const handleFinish = () => {
    setTimeout(() => {
      restartInteraction();
    }, 5000);
  };

  const handleFailedActivation = () => {
    setPage(PAGES.LAUNDRY_ACTIVATION_ERROR);
  };

  return (
    <GradientContainer>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Title style={{ marginBottom: "2rem" }}>Sucesso!</Title>
        <Subtitle fontSize="2.5rem">A máquina será acionada</Subtitle>
        <Subtitle fontSize="2.5rem">em 5 segundos</Subtitle>
      </TextContainer>
    </GradientContainer>
  );
};

export default SuccessPayment;
